<template>
  <div>
    <el-form class="searchForm mb20" label-position="top">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorAlias')">
            <el-row :gutter="4">
              <el-col :span="18">
                <!-- <el-select v-model="searchForm.vendorAliasIds" multiple collapse-tags filterable clearable>
                  <el-option v-for="item in vendorAliasList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                </el-select> -->
                <BrandSelect :data="vendorAliasList" v-model="searchForm.vendorAliasIds" multiple collapse-tags filterable clearable></BrandSelect>
              </el-col>
              <el-col :span="6">
                <el-button @click="showBatchVendorForm" style="width: 100%;padding-left: 0;padding-right: 0;background-color: #F5F7FA;">批量</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorId')">
            <el-row :gutter="4">
              <el-col :span="18">
                <el-input v-model="searchForm.inputVendorId" clearable></el-input>
              </el-col>
              <el-col :span="6">
                <el-button @click="showBatchVendorIdForm" style="width: 100%;padding-left: 0;padding-right: 0;background-color: #F5F7FA;">批量</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showVendorName">
          <el-form-item :label="$t('crm.vendorName')">
            <!-- <el-select v-model="searchForm.vendorId" filterable clearable>
              <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select> -->
            <BrandSelect :data="vendorList" v-model="searchForm.vendorId" filterable clearable multiple collapse-tags></BrandSelect>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.systemName')">
            <el-select v-model="searchForm.vendorSystemId" filterable clearable>
              <el-option v-for="item in systemList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorType')">
            <el-select v-model="searchForm.vendorType" clearable>
              <el-option v-for="item in vendorTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('common.country')">
            <el-select v-model="searchForm.addressCountryId" filterable clearable>
              <el-option v-for="item in countryList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorStoreStatus')">
            <el-select v-model="searchForm.vendorStatus" clearable>
              <el-option v-for="item in vendorStatusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorCurrency')">
            <el-select v-model="searchForm.originalPriceType" clearable>
              <el-option v-for="item in unitList" :label="item.label" :value="item.value" :key="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('crm.vendorCode')">
            <el-input v-model="searchForm.storeCode" clearable></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.productConnectivityMethod')">
            <el-select v-model="searchForm.productSourceType" clearable>
              <el-option v-for="item in vendorProductSourceTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.stockConnectivityMethod')">
            <el-select v-model="searchForm.storageType" clearable>
              <el-option :value="1" label="Pending(可用库存)"></el-option>
              <el-option :value="2" label="Confirmed"></el-option>
              <el-option :value="3" label="Ship(全部库存)"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.pricingConnectivityMethod')">
            <el-select v-model="searchForm.priceType" clearable>
              <el-option v-for="item in supplyPriceMethodList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.vendorRegion')">
            <el-select v-model="searchForm.businessRegionId" clearable>
              <el-option v-for="(item, idx) in businessRegionList" :key="idx" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.imRepresentative')">
            <el-select v-model="searchForm.boutiqueSaleConcatId" filterable clearable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.imAssistantRepresentative')">
            <el-select v-model="searchForm.boutiqueAssistantId" filterable clearable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.preSaleAvailablity')">
            <el-select v-model="searchForm.isPreSale" clearable>
              <el-option :label="$t('crm.supportPreSale')" :value="1"></el-option>
              <el-option :label="$t('crm.notSupportPreSale')" :value="2"></el-option>
              <el-option :label="$t('crm.rollingPreSale')" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.editStatus')">
            <el-select v-model="searchForm.auditStatus" clearable>
              <el-option :label="$t('crm.auditStatus0')" :value="0"></el-option>
              <el-option :label="$t('crm.auditStatus2')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.checkLogisticsConf')">
            <el-select v-model="searchForm.isTmsFinished" clearable>
              <el-option :label="$t('common.yes')" :value="1"></el-option>
              <el-option :label="$t('common.no')" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" v-if="showMoreQuery">
          <el-form-item :label="$t('crm.parentCompanyName')">
            <el-select v-model="searchForm.crmGroupId" filterable clearable>
              <el-option v-for="item in groupByList" :label="item.groupName" :value="item.crmGroupInfoId" :key="item.crmGroupInfoId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="form-btn">
            <el-button type="text" @click="showMoreQuery = !showMoreQuery">{{showMoreQuery ? $t('common.putAway') : $t('common.expandAllConditions')}}</el-button>
            <el-button class="ml20" type="primary" @click="searchTableData(true)">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearchForm">{{ $t('common.reset') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <div class="mb10">
      <el-button type="primary" v-if="batchUpdateBDBtn" @click="showBatchUpdateBD" :disabled="multipleSelection.length === 0">{{ $t('crm.batchUpdateBD') }}</el-button>
    </div>

    <el-table :data="tableData" ref="searchTable" @selection-change="handleSelectionChange" :header-cell-style="{backgroundColor: '#f0f0f0'}" border v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column :label="$t('crm.vendorId')" prop="vendorId"></el-table-column>
      <el-table-column :label="$t('crm.storeCode')" prop="storeCode"></el-table-column>
      <el-table-column :label="$t('crm.vendorName')">
        <template slot-scope="scope">
          <template v-if="showVendorName">
            <template v-if="scope.row.vendorTypeId === 5">{{ scope.row.vendorName }}</template>
            <el-link v-else type="primary" @click="openPortal(scope.row)">{{ scope.row.vendorName }}</el-link>
            <p>/</p>
            {{ scope.row.vendorNameAlias }}
          </template>
          <template v-else>
            <template v-if="scope.row.vendorTypeId === 5">{{ scope.row.vendorNameAlias }}</template>
            <el-link v-else type="primary" @click="openPortal(scope.row)">{{ scope.row.vendorNameAlias }}</el-link>
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('crm.vendorCode')" prop="storeCode"></el-table-column> -->
      <el-table-column :label="$t('crm.systemName')" prop="systemName"></el-table-column>
      <el-table-column :label="$t('crm.vendorType')" prop="vendorType">
        <template slot-scope="scope">
            {{scope.row.vendorType}}{{ scope.row.wholesaleType == 1 ? "（现货货单）" : scope.row.wholesaleType == 4 ? "（品牌补货）" : scope.row.wholesaleType == 5 ? "（期货预售）" : "" }}
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('crm.infoCompletion')" prop="">
        <template slot-scope="scope">
          <span v-if="scope.row.vendorAsPerfection || scope.row.vendorAsPerfection == 0">
            {{ Math.round(scope.row.vendorAsPerfection * 100) }}%
          </span>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('common.country')" prop="addressCountryName"></el-table-column>
      <el-table-column :label="$t('crm.vendorCurrency')" prop="originalPriceUnit"></el-table-column>
      <el-table-column :label="$t('crm.productConnectivityMethod')" prop="productSourceType"></el-table-column>
      <!-- <el-table-column :label="$t('crm.stockConnectivityMethod')" prop="stockType"></el-table-column> -->
      <el-table-column :label="$t('crm.pricingConnectivityMethod')" prop="supplyPriceMethod"></el-table-column>
      <el-table-column :label="$t('crm.vendorRegion')" prop="businessRegion"></el-table-column>
      <el-table-column :label="$t('crm.imRepresentative')" prop="boutiqueBdId">
        <template slot-scope="scope">
          {{ boutiqueBdMap[scope.row.boutiqueBdId] }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.imAssistantRepresentative')" prop="boutiqueAssistantId">
        <template slot-scope="scope">
          {{ boutiqueBdMap[scope.row.boutiqueAssistantId] }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.saleChannels')">
        <template slot-scope="scope">
          <div v-if="scope.row.saleChannels && scope.row.saleChannels.length">
            <div v-for="(item, index) in scope.row.saleChannels" :key="index">
              {{ item }}
            </div>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.vendorStoreStatus')">
        <template slot-scope="scope">
          <p>{{ scope.row.vendorStatus }}</p>
          <p v-if="scope.row.auditStatus === 0" class="f12">(<span class="red">{{ $t('crm.auditStatus0') }}</span>)</p>
          <p v-if="scope.row.auditStatus === 2" class="f12">(<span class="red">{{ $t('crm.auditStatus2') }}</span>)</p>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('crm.preSaleAvailablity')" prop="isPreSale"></el-table-column> -->
      <el-table-column :label="$t('common.action')" width="260">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="basicInfoBtn || paymentBtn || vendorContactsBtn || otherSaleChannelInfoBtn || imBusinessStatusBtn || shipmentStockLocationInfoBtn" @click="showDetail(scope.row.vendorId)">{{ $t('crm.viewVendorInfo') }}</el-button>
          <el-button type="text" size="small" v-if="editVendorBtn && scope.row.auditStatus !== 0 && scope.row.auditStatus !== 2" @click="editVendor(scope.row.vendorId)">{{ $t('crm.editVendorInfo') }}</el-button>
          <el-button type="text" size="small" v-if="editVendorBtn && scope.row.auditStatus === 2" @click="editVendorAgain(scope.row.vendorId)">{{ $t('crm.reEdit') }}</el-button>
          <el-button type="text" size="small" v-if="auditBtn && scope.row.auditStatus === 0" @click="showAudit(scope.row.vendorId)">{{ $t('crm.audit') }}</el-button>
          <el-button type="text" size="small" v-if="techInfoBtn" @click="goTech(scope.row)">{{ $t('crm.editTechInfo') }}</el-button>
          <el-button type="text" size="small" v-if="storeStatusBtn && scope.row.vendorStatusNum === 1" @click="updateVendorStatus(scope.row, 3)">{{ $t('crm.suspensionBusiness') }}</el-button>
          <el-button type="text" size="small" v-if="storeStatusBtn && scope.row.vendorStatusNum === 1" @click="updateVendorStatus(scope.row, 0)">{{ $t('crm.updateStatusToPending') }}</el-button>
          <el-button type="text" size="small" v-else-if="storeStatusBtn && scope.row.vendorStatusNum !== 5" @click="updateVendorStatus(scope.row, 1)">{{ $t('crm.startBusiness') }}</el-button>
          <el-button type="text" size="small" v-if="apiBtn" @click="goApi(scope.row)">{{ $t('crm.apiPermissionConf') }}</el-button>
          <el-button type="text" size="small" v-if="portalUserBtn" @click="showPortalOperator(scope.row)">{{ $t('crm.addPortalOperator') }}</el-button>
          <el-button type="text" size="small" v-if="aftersafeBtn" @click="editAfterSale(scope.row.vendorId)">{{ $t('crm.afterSalesInfoManage') }}</el-button>
          <el-button type="text" size="small" v-if="addVisitLogBtn" @click="showVisitForm(scope.row)">{{ $t('crm.addVisitRecord') }}</el-button>
          <el-button type="text" size="small" v-if="destroyBtn && scope.row.vendorStatusNum !== 5 && scope.row.vendorTypeId === 5" @click="destroyStore(scope.row)">{{ $t('crm.destroyStore') }}</el-button>
          <el-button type="text" size="small" v-if="addFastBtn && scope.row.showFastBanButton == 1" @click="fastBanSale(1,scope.row.vendorId)">{{ $t('crm.addFast') }}</el-button>
          <el-button type="text" size="small" v-if="deleteFastBtn && scope.row.showFastBanButton == 2" @click="fastBanSale(2,scope.row.vendorId)">{{ $t('crm.deleteFast') }}</el-button>
          <el-button type="text" size="small" v-if="vendorTypeBtn" @click="showType(scope.row.vendorId)">店铺数据分类</el-button>
          <el-button type="text" size="small" v-if="settlementBtn" @click="toggleSettlement(scope.row)">{{ scope.row.hasSettlement ? $t('crm.closeSettlement') : $t('crm.openSettlement') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr mt10">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="searchForm.currentPage"
        small
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total,sizes,prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog :title="$t('crm.portalOperator')" :visible.sync="dialogVisible" width="300px">
      <ul class="user-list">
        <li v-for="(item, index) in operationUserList" :key="item.userId"><span>{{ item.userName }}</span><i @click="removeUser(index)" class="el-icon-delete"></i></li>
      </ul>
      <el-select class="mt10" size="mini" v-model="currUser" filterable style="width: 150px">
        <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item" :key="item.value"></el-option>
      </el-select>
      <el-button class="ml5" size="mini" type="primary" @click="addUser">{{ $t('common.add') }}</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitPortalUser">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.addVisitRecord')" :visible.sync="dialogVisibleVisitForm" width="500px">
      <el-form :model="visitForm" ref="visitForm" label-width="120px">
        <el-form-item :label="$t('crm.logVisitType')" prop="visitType">
          <el-input v-model="visitForm.visitType"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.logVisitDate')" prop="visitTime">
          <el-date-picker
            v-model="visitForm.visitTime"
            type="datetime"
            :editable="false"
            :clearable="false"
            value-format="timestamp"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm.logVisitPurpose')" prop="visitPurpose">
          <el-input type="textarea" :rows="2" v-model="visitForm.visitPurpose"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.logComeToAgreement')" prop="agreement">
          <el-input type="textarea" :rows="2" v-model="visitForm.agreement"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.logRemark')" prop="remark">
          <el-input type="textarea" :rows="2" v-model="visitForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleVisitForm = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitVisitForm">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.storeCannotBeDestroyed')" :visible.sync="dialogVisibleDestroy" width="400px">
      <p class="red" v-for="(item, index) in destroyResult" :key="index">{{ index + 1 }} {{ $t(`crm.${item}`) }}</p>
    </el-dialog>

    <el-dialog :title="$t('crm.batchUpdateBD')" :visible.sync="dialogVisibleEditBD" width="500px">
      <el-form :model="editBDForm" ref="editBDForm" label-width="140px">
        <el-form-item :label="$t('crm.imRepresentative')" prop="visitType">
          <el-select v-model="editBDForm.boutiqueBdId" filterable>
            <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('crm.imAssistantRepresentative')" prop="visitTime">
          <el-select v-model="editBDForm.boutiqueAssistantId" filterable clearable>
            <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-alert :title="$t('crm.batchUpdateBDTip')" type="error" :closable="false"></el-alert>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEditBD = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" :disabled="!editBDForm.boutiqueBdId && !editBDForm.boutiqueAssistantId" @click="submitUpdateBD">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.batchSelectVendor')" :visible.sync="dialogVisibleBatchVendor" :close-on-click-modal="false" width="500px">
      <p class="mb10">{{ $t('crm.batchEnterVendorTip') }}</p>
      <el-alert v-if="invalidVendorList.length > 0" :title="$t('crm.batchVendorNotExistTip')" class="mb10" type="error" effect="dark" :closable="false">
        {{ invalidVendorList.join(', ') }}
      </el-alert>
      <el-checkbox class="mb10" v-model="inputVendorReverse">{{ $t('crm.batchVendorReverseTip') }}</el-checkbox>
      <el-input
        type="textarea"
        :rows="14"
        v-model="inputVendorStr">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBatchVendor = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitInputVendorStr">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.batchSelectVendorId')" :visible.sync="dialogVisibleBatchVendorId" :close-on-click-modal="false" width="500px">
      <p class="mb10">{{ $t('crm.batchEnterVendorIdTip') }}</p>
      <el-alert v-if="invalidVendorList.length > 0" :title="$t('crm.batchVendorIdNotExistTip')" class="mb10" type="error" effect="dark" :closable="false">
        {{ invalidVendorList.join(', ') }}
      </el-alert>
      <el-checkbox class="mb10" v-model="inputVendorReverse">{{ $t('crm.batchVendorReverseTip') }}</el-checkbox>
      <el-input
        type="textarea"
        :rows="14"
        v-model="inputVendorStr">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBatchVendorId = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitInputVendorId">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="店铺数据分类"
      :visible.sync="dialogTypeVisible"
      width="500px"
      :before-close="handleCloseType"
    >
      <el-form
        label-width="130px"
        :model="formAdd"
        ref="ruleForms"
      >
        <el-form-item label="IM业务类型：" prop="imType">
          <el-select v-model="formAdd.imType" filterable clearable>
            <el-option v-for="item in imTypeList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商类型" prop="supplierType">
          <el-select v-model="formAdd.supplierType" filterable clearable>
            <el-option v-for="item in supplierTypeList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品品相" prop="productType">
          <el-select v-model="formAdd.productType" filterable clearable>
            <el-option v-for="item in productTypeList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品获取方式" prop="fromType">
          <el-select v-model="formAdd.fromType" filterable clearable>
            <el-option v-for="item in fromTypeList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseType">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getVendorList as getTableData,
  updateVendorStatus,
  getPortalToken,
  addPortalUser,
  addBusinessVisit,
  checkDestroy,
  sellerDestroy,
  batchUpdateBDInfo,
  fastBanSale,
  getVendorInfo,
  updateVendorInfo,
  addVendorSettlement,
  removeVendorSettlement
} from '../api';
import BrandSelect from '@/views/components/brandSelect.vue';

export default {
  props: {
    vendorList: Array,
    vendorAliasList: Array,
    systemList: Array,
    vendorTypeList: Array,
    countryList: Array,
    vendorStatusList: Array,
    unitList: Array,
    vendorProductSourceTypeList: Array,
    supplyPriceMethodList: Array,
    businessRegionList: Array,
    boutiqueBdList: Array,
    boutiqueBdMap: Object,
    groupByList: Array,
  },
  components: {BrandSelect},
  data() {
    return {
      searchForm: {
        vendorId: [],
        vendorAliasIds: [],
        inputVendorId: null,
        vendorSystemId: null,
        vendorType: null,
        addressCountryId: null,
        vendorStatus: null,
        originalPriceType: null,
        storeCode: null,
        productSourceType: null,
        storageType: null,
        priceType: null,
        businessRegionId: null,
        boutiqueAssistantId: null,
        boutiqueSaleConcatId: null,
        auditStatus: null,
        isTmsFinished: null,
        isPreSale: null,
        crmGroupId: null,
        currentPage: 1,
        pageSize: 25,
      },
      loading: false,
      tableData: [],
      totalCount: 0,
      showMoreQuery: false,
      dialogVisible: false,
      currUser: null,
      currVendorId: null,
      operationUserList: [],
      dialogVisibleVisitForm: false,
      visitForm: {
        vendorId: null,
        visitType: null,
        visitTime: null,
        visitPurpose: null,
        agreement: null,
        remark: null,
      },
      dialogVisibleDestroy: false,
      destroyResult: [],
      dialogVisibleEditBD: false,
      editBDForm: {
        boutiqueBdId: null,
        boutiqueAssistantId: null,
        boutiqueAssistantTwoId: null,
      },
      multipleSelection: [],
      invalidVendorList: [],
      inputVendorStr: '',
      inputVendorReverse: false,
      dialogVisibleBatchVendor: false,
      dialogVisibleBatchVendorId: false,
      formAdd: {},
      imTypeList: [         "信息(不可售)",
         "专柜",
         "MP",
         "B2B-现货",
         "虚拟库存",
         "国现",
         "B2B-品牌补货",
         "B2B-预售",
         "B2B-期货"],
      supplierTypeList: [         "个卖",
         "测试/对接",
         "买手店",
         "自营电商网站",
         "品牌官网",
         "品牌中国官网",
         "品牌",
         "自营",
         "贸易商",
         "电商平台",
         "百货",
         "奥莱"],
      productTypeList: ["常规","档案(非销售)","常规-自有货号","瑕疵"],
      fromTypeList: ["手工","API","爬虫","拍照上传"],
      rules:{
        imType: [{required: true,message: "请选择",trigger: "change"}],
        supplierType: [{required: true,message: "请选择",trigger: "change"}],
        productType: [{required: true,message: "请选择",trigger: "change"}],
        fromType: [{required: true,message: "请选择",trigger: "change"}]
      },
      dialogTypeVisible: false
    };
  },
  computed: {
    ...mapState({
      basicInfoBtn: (state) => state.app.menuMap['商家CRM-hide-查看基本信息'],
      paymentBtn: (state) => state.app.menuMap['商家CRM-hide-查看支付信息'],
      vendorContactsBtn: (state) => state.app.menuMap['商家CRM-hide-查看商家联络信息'],
      otherSaleChannelInfoBtn: (state) => state.app.menuMap['商家CRM-hide-查看其他业务渠道'],
      shipmentStockLocationInfoBtn: (state) => state.app.menuMap['商家CRM-hide-查看物流&发货地信息'],
      editVendorBtn: (state) => state.app.menuMap['商家CRM-hide-编辑商家信息'],
      auditBtn: (state) => state.app.menuMap['商家CRM-hide-去审核'],
      apiBtn: (state) => state.app.menuMap['商家CRM-hide-接口权限配置'],
      storeStatusBtn: (state) => state.app.menuMap['商家CRM-hide-停/启营业'],
      techInfoBtn: (state) => state.app.menuMap['商家CRM-hide-技术信息配置'],
      imBusinessStatusBtn: (state) => state.app.menuMap['商家CRM-hide-IM业务'],
      portalUserBtn: (state) => state.app.menuMap['商家CRM-hide-增加portal操作员'],
      aftersafeBtn: (state) => state.app.menuMap['商家CRM-hide-履约售后信息维护'],
      addVisitLogBtn: (state) => state.app.menuMap['商家CRM-hide-添加拜访日志'],
      destroyBtn: (state) => state.app.menuMap['商家CRM-hide-注销店铺'],
      showVendorName: (state) => state.app.menuMap['商家CRM-hide-查看买手店名称'],
      batchUpdateBDBtn: (state) => state.app.menuMap['商家CRM-hide-批量更改BD和助理'],
      addFastBtn: (state) => state.app.menuMap['商家CRM-hide-禁售'],
      deleteFastBtn: (state) => state.app.menuMap['商家CRM-hide-移除禁售'],
      vendorTypeBtn: (state) => state.app.menuMap['商家CRM-hide-店铺数据分类'],
      settlementBtn: (state) => state.app.menuMap['商家CRM-hide-结算功能'],
    })
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    fastBanSale(operateType,vendorId){
      fastBanSale({
        operateType,
        vendorId
      }).then(res => {
        if(res.data.success){
          this.$message.success(this.$t('common.successful'));
          this.getTableData();
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    goTech(row){ //跳转编辑技术
      let {vendorId,vendorTypeId,productSourceTypeId} = row;
      window.open(`/#/crm/cn/edittechnology?vendorId=${vendorId}&vendorTypeId=${vendorTypeId}&productSourceTypeId=${productSourceTypeId}`);
    },
    searchTableData() {
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    resetSearchForm() {
      this.searchForm.vendorAliasIds = [];
      this.searchForm.vendorId = [];
      this.searchForm.inputVendorId = null;
      this.searchForm.vendorSystemId = null;
      this.searchForm.vendorType = null;
      this.searchForm.addressCountryId = null;
      this.searchForm.vendorStatus = null;
      this.searchForm.originalPriceType = null;
      this.searchForm.storeCode = null;
      this.searchForm.productSourceType = null;
      this.searchForm.storageType = null;
      this.searchForm.priceType = null;
      this.searchForm.businessRegionId = null;
      this.searchForm.boutiqueAssistantId = null;
      this.searchForm.boutiqueSaleConcatId = null;
      this.searchForm.auditStatus = null;
      this.searchForm.isTmsFinished = null;
      this.searchForm.isPreSale = null;
      this.searchForm.crmGroupId = null;
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let vendorIds = [];
      if (this.searchForm.inputVendorId) {
        vendorIds = (this.searchForm.inputVendorId + "").split(",");
      } else if (this.searchForm.vendorAliasIds.length > 0) {
        vendorIds = this.searchForm.vendorAliasIds;
      } else if (this.searchForm.vendorId && this.searchForm.vendorId.length > 0) {
        vendorIds = this.searchForm.vendorId;
      }
      getTableData({
        ...this.searchForm,
        vendorIds,
        vendorSystemId: (this.searchForm.vendorSystemId || this.searchForm.vendorSystemId === 0) ? [this.searchForm.vendorSystemId] : null,
        vendorType: (this.searchForm.vendorType || this.searchForm.vendorType === 0) ? [this.searchForm.vendorType] : null,
        addressCountryId: (this.searchForm.addressCountryId || this.searchForm.addressCountryId === 0) ? [this.searchForm.addressCountryId] : null,
        vendorStatus: (this.searchForm.vendorStatus || this.searchForm.vendorStatus === 0) ? [this.searchForm.vendorStatus] : null,
        originalPriceType: (this.searchForm.originalPriceType || this.searchForm.originalPriceType === 0) ? [this.searchForm.originalPriceType] : null,
      }).then(res => {
        if (res.data && res.data.success) {
          this.tableData = res.data.data.list;
          this.totalCount = res.data.data.total;
        }
        this.loading = false;
      });
    },
    handleCurrentChange(currentPage) {
      this.searchForm.currentPage = currentPage;
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getTableData();
    },
    showDetail(vendorId) {
      window.open(`/#/crm/cn/${vendorId}`);
    },
    editVendor(vendorId) {
      window.open(`/#/crm/cn/edit/${vendorId}`);
    },
    editVendorAgain(vendorId) {
      window.open(`/#/crm/cn/edit/${vendorId}/1`);
    },
    showAudit(vendorId) {
      window.open(`/#/crm/cn/audit/${vendorId}`);
    },
    editAfterSale(vendorId) {
      window.open(`/#/crm/cn/aftersale/${vendorId}`);
    },
    updateVendorStatus(row, status) {
      this.$confirm("确认当前操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        updateVendorStatus({
          vendorId: row.vendorId,
          vendorStatus: status,
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(this.$t('common.successful'));
            this.getTableData();
          } else {
            this.$confirm(res.data.message, this.$t('common.message'), {
              confirmButtonText: this.$t('crm.lookAgain'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
            }).catch(() => {
            });
          }
        })
      }).catch(() => {
        this.$message({ type: "info", message: "已取消操作" });
      });
    },
    toggleSettlement(row) {
      const closing = !!row.hasSettlement;
      const doSettlement = () => {
        const api = closing ? removeVendorSettlement : addVendorSettlement;
        api({ vendorId: row.vendorId }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(closing ? this.$t('crm.closeSettlementSuccess') : this.$t('crm.openSettlementSuccess'));
            this.getTableData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      };
      //开通/关闭结算功能均属敏感操作，二次确认
      this.$confirm(closing ? this.$t('crm.confirmCloseSettlement') : this.$t('crm.confirmOpenSettlement'), this.$t('common.message'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => doSettlement()).catch(() => {});
    },
    goApi(row) {
      window.open(`/#/buyershop/dockingAuth/${row.vendorId}`)
    },
    openPortal(row) {
      getPortalToken({ vendorId: row.vendorId }).then(res => {
        if (res.data && res.data.success) {
          window.open(`${process.env.VUE_APP_PORTAL_CN}?token=${res.data.data}`);
          // window.open(`http://localhost:8080/portal/?token=${res.data.data}`);
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      })
    },
    showPortalOperator(row) {
      this.currUser = null;
      this.currVendorId = row.vendorId;
      this.operationUserList = JSON.parse(JSON.stringify(row.userList)) || [];
      this.dialogVisible = true;
    },
    addUser() {
      if (this.operationUserList.every(item => item.userId !== this.currUser.value)) {
        this.operationUserList.push({
          userId: this.currUser.value,
          userName: this.currUser.label,
        });
      }
      this.currUser = null;
    },
    submitPortalUser() {
      if (this.currUser != null) {
        this.addUser();
      }
      addPortalUser({
        vendorId: this.currVendorId,
        userInfos: this.operationUserList,
      }).then(res => {
        if (res.data && res.data.success) {
          this.getTableData();
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      })
    },
    removeUser(index) {
      this.operationUserList.splice(index, 1);
    },
    showVisitForm(row) {
      this.visitForm.vendorId = row.vendorId;
      this.visitForm.visitType = null;
      this.visitForm.visitTime = null;
      this.visitForm.visitPurpose = null;
      this.visitForm.agreement = null;
      this.visitForm.remark = null;
      this.dialogVisibleVisitForm = true;
      this.$nextTick(() => {
        this.$refs.visitForm.clearValidate();
      })
    },
    submitVisitForm() {
      addBusinessVisit(this.visitForm).then(res => {
        if (res.data && res.data.success) {
          this.$message.success(this.$t('common.successful'));
          this.dialogVisibleVisitForm = false;
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      });
    },
    destroyStore(row) {
      this.currVendorId = row.vendorId;
      this.destroyResult = [];
      checkDestroy({
        vendorId: row.vendorId,
      }).then(res => {
        if (res.data && res.data.success) {
          if (res.data.data.checkIsPassed) {
            this.$confirm(this.$t('crm.confirmDestroyStore'), this.$t('common.message'), {
              confirmButtonText: this.$t('common.ok'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning',
            }).then(() => {
              this.sellerDestroy();
            }).catch(() => {});
          } else {
            this.showStoreRelation(res.data.data);
          }
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      })
    },
    showStoreRelation(data) {
      if (data.unclaimedBalanceStatus) {
        this.destroyResult.push('unclaimedBalanceStatus');
      }
      if (data.unSettlementOrderStatus) {
        this.destroyResult.push('unSettlementOrderStatus');
      }
      if (data.unSettlementAmountStatus) {
        this.destroyResult.push('unSettlementAmountStatus');
      }
      this.dialogVisibleDestroy = true;
    },
    sellerDestroy() {
      this.destroyResult = [];
      sellerDestroy({
        vendorId: this.currVendorId,
      }).then(res => {
        if (res.data && res.data.success) {
          if (res.data.data.checkIsPassed) {
            this.$message.success(this.$t('common.successful'));
            this.getTableData();
          } else {
            this.showStoreRelation(res.data.data);
          }
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      })
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    showBatchUpdateBD() {
      this.editBDForm.boutiqueBdId = null;
      this.editBDForm.boutiqueAssistantId = null;
      this.editBDForm.boutiqueAssistantTwoId = null;
      this.dialogVisibleEditBD = true;
    },
    submitUpdateBD() {
      batchUpdateBDInfo({
        ...this.editBDForm,
        vendorIds: this.multipleSelection.map(item => item.vendorId),
        boutiqueBdName: this.editBDForm.boutiqueBdId ? this.boutiqueBdList.find(item => item.value === this.editBDForm.boutiqueBdId).label : '',
        boutiqueAssistantName: this.editBDForm.boutiqueAssistantId ? this.boutiqueBdList.find(item => item.value === this.editBDForm.boutiqueAssistantId).label : ''
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success(this.$t('common.successful'));
          this.getTableData();
          this.dialogVisibleEditBD = false;
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      });
    },
    showBatchVendorForm() {
      this.invalidVendorList = [];
      this.inputVendorStr = '';
      this.inputVendorReverse = false;
      this.dialogVisibleBatchVendor = true;
    },
    submitInputVendorStr() {
      this.invalidVendorList = [];
      const idList = this.inputVendorStr.split('\n').filter(item => item.trim()).map(item => item.trim());
      if (idList.length === 0) {
        this.$message(this.$t('common.plzInput') + this.$t('crm.vendorName'));
        return;
      }
      if (idList.length > 1000) {
        this.$message.error(this.$t('crm.batchVendorLimitTip'));
        return;
      }
      const vendorIds = [];
      idList.forEach(id => {
        const flag = this.vendorAliasList.some(item => {
          if (item.label.toLocaleLowerCase() === id.toLocaleLowerCase()) {
            vendorIds.push(item.value);
            return true;
          }
          return false;
        });
        if (!flag) {
          this.invalidVendorList.push(id);
        }
      });
      if (this.invalidVendorList.length > 0) {
        return;
      }
      if (this.inputVendorReverse) {
        this.searchForm.vendorAliasIds = this.vendorAliasList.filter(item => {
          return !vendorIds.includes(item.value);
        }).map(item => item.value);
      } else {
        this.searchForm.vendorAliasIds = vendorIds;
      }
      this.dialogVisibleBatchVendor = false;
    },
    showBatchVendorIdForm() {
      this.invalidVendorList = [];
      this.inputVendorStr = '';
      this.inputVendorReverse = false;
      this.dialogVisibleBatchVendorId = true;
    },
    submitInputVendorId() {
      this.invalidVendorList = [];
      const idList = this.inputVendorStr.split('\n').filter(item => item.trim()).map(item => item.trim());
      if (idList.length === 0) {
        this.$message(this.$t('common.plzInput') + this.$t('crm.vendorId'));
        return;
      }
      if (idList.length > 1000) {
        this.$message.error(this.$t('crm.batchVendorLimitTip'));
        return;
      }
      const vendorIds = [];
      idList.forEach(id => {
        const flag = this.vendorAliasList.some(item => {
          if (item.value == id) {
            vendorIds.push(item.value);
            return true;
          }
          return false;
        });
        if (!flag) {
          this.invalidVendorList.push(id);
        }
      });
      if (this.invalidVendorList.length > 0) {
        return;
      }
      if (this.inputVendorReverse) {
        this.searchForm.inputVendorId = this.vendorAliasList.filter(item => {
          return !vendorIds.includes(item.value);
        }).map(item => item.value).join(',');
      } else {
        this.searchForm.inputVendorId = vendorIds.join(',');
      }
      this.dialogVisibleBatchVendorId = false;
    },
    showType(vendorId) {
      this.dialogTypeVisible = true;
      getVendorInfo({vendorId}).then(res =>{
        console.log(res)
        var formAdd ={};
        res.data.data.map(item => {
          if (item.infoType == 5){
            formAdd.imType = item.data
          }else if (item.infoType == 6){
            formAdd.supplierType = item.data
          }else if (item.infoType == 7){
            formAdd.productType = item.data
          }else if (item.infoType == 8){
            formAdd.fromType = item.data
          }
        })
        this.formAdd = {
          ...formAdd,
          vendorId:vendorId
        }
      })
    },
    handleCloseType(){
      this.dialogTypeVisible = false;
    },
    submit(){
      var params = [
        {"vendorId": this.formAdd.vendorId,"infoType":5,"data":this.formAdd.imType},
        {"vendorId": this.formAdd.vendorId,"infoType":6,"data":this.formAdd.supplierType},
        {"vendorId": this.formAdd.vendorId,"infoType":7,"data":this.formAdd.productType},
        {"vendorId": this.formAdd.vendorId,"infoType":8,"data":this.formAdd.fromType}]
      updateVendorInfo(params).then(res =>{
        console.log(res)
        if (res.data.success){
          this.$message.success("提交成功");
          this.dialogTypeVisible = false;
        }else{
          this.$message.error(res.data.messgae);

        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.form-btn {
  margin-top: 40px;
}
.ml5 {
  margin-left: 5px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml20 {
  margin-left: 20px;
}
.tr {
  text-align: right;
}
.f12 {
  font-size: 12px;
}
.red {
  color: red;
}
.user-list {
  list-style: none;
  padding: 0;

  span {
    width: 150px;
    padding: 3px 0;
    margin-right: 10px;
  }
  i {
    display: none;
  }
  li {
    display: flex;
    align-items: center;
    &:hover {
      color: #409EFF;
      i {
        display: block;
      }
    }
  }
}
</style>
<style lang="less">
.searchForm {
  .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
